import OBConsentDetailsScreen from './pages/ob-consent-details-screen.component';

export const modals = {
  CONSENT_DETAILS: OBConsentDetailsScreen
};

export default modals;
